<template>
    <div class="card">
        <div class="card-header p-2" style="min-height: 46px">
            <div class="input-group" style="border: 1px solid #ced4da;">
                <div class="input-group-prepend">
                    <span class="input-group-text" style="border: none;">Ciclo escolar</span>
                </div>

                <select class="form-control" id="alumnos_ciclos_id" :disabled="loading" v-model="selectedCicloId" @change="selectCiclo()">
                    <option disabled selected value="">Selecciona Ciclo Escolar...</option>
                    <option v-for="ciclo in ciclos" :key="ciclo.id" :value="ciclo.id">{{ ciclo.text }}</option>
                </select>

                <div class="input-group-append" style="background-color: #17a2b8;">
                    <button class="btn btn-sm btn-secondary" data-toggle="modal" data-target="#MigrarAlumnosModal" :disabled="!selectedGrupo || loading">
                        Migrar Alumnos
                    </button>

                    <button class="btn btn-sm btn-secondary" data-toggle="modal" data-target="#CargarAlumnosModal" :disabled="!selectedGrupo || loading">
                        Cargar Alumnos
                    </button>

                    <button class="btn btn-sm btn-secondary" data-toggle="modal" data-target="#CargarProspectosModal" :disabled="!selectedGrupo || loading">
                        Cargar Prospectos
                    </button>

                    <AccionesGrupo />
                </div>

            </div>
        </div>

        <div class="card-body p-0" style="background-color: rgb(255, 255, 255)">
            <div class="list-group arbol-max-height">

                <div v-if="!selectedGrupo" class="list-group-item" style="border: none;">
                    <div class="text-center p-3 mb-0">
                        <h5 class="mb-0">Selecciona un grupo para continuar</h5>
                    </div>
                </div>

                <div v-if="!loading && selectedGrupo && alumnos && alumnos.length == 0">
                    <div class="alert alert-warning" role="alert">
                        Este grupo aun no tiene alumnos
                    </div>
                </div>

                <div class="text-center mt-5" v-if="loading">
                    <div class="spinner-border text-primary" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                </div>

                <div v-if="!loading && selectedGrupo">
                    <div v-for="alumno in alumnos" :key="alumno.id" class="list-group-item" style="border: none; border-bottom: 1px solid rgba(0, 0, 0, 0.125);">
                        <div class="d-flex justify-content-between align-items-center">
                            <h5 v-text="alumno.no_lista ? alumno.no_lista + '. ' + alumno.apellido_paterno + ' ' + alumno.apellido_materno  + ' ' + alumno.nombres : alumno.apellido_paterno + ' ' + alumno.apellido_materno  + ' ' + alumno.nombres" class="m-0"></h5>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AccionesGrupo from './AccionesGrupo';

export default {
    name: 'Alumnos',
    inject: ['ciclos$', 'alumnos$', 'loadingAlumnos$', 'selectedGrupoChange$', 'selectedCicloChange$'],
    data() {
        return {
            loading: false,
            selectedCicloId: '',
            selectedGrupo: null,
            ciclosCache: []
        }
    },
    mounted() {
        this.loadingAlumnos$.subscribe(loading => this.loading = loading);
        this.selectedGrupoChange$.subscribe(grupo => this.selectedGrupo = grupo);

        this.ciclos$.subscribe(ciclos => {
            this.ciclosCache = ciclos;
            this.selectedCicloId = ciclos[0].id;
            this.selectCiclo();
        });
    },
    methods: {
        selectCiclo() {
            this.selectedCicloChange$.next(this.ciclosCache.find(ciclo => ciclo.id == this.selectedCicloId))
        },
        grupoIsActive() {
            if (!this.selectedGrupo.adminCiclo) {
                return true;
            }

            return this.selectedGrupo.adminCiclo.find(ac => ac.ciclo_escolar_id == this.selectedCicloId).active ?? true;
        }
    },
    subscriptions () {
        return {
            ciclos: this.ciclos$,
            alumnos: this.alumnos$
        }
    },
    components: {
        AccionesGrupo
    }
}
</script>

<style>

</style>
